import React from 'react';
import { useNavigate } from 'react-router-dom';

const STATUS_COLORS = {
  draft: 'var(--color-text-muted)',
  em_producao: 'var(--color-warning)',
  aprovado: 'var(--color-accent)',
  publicado: 'var(--color-success)',
};

function ClientCard({ client }) {
  const navigate = useNavigate();
  const initials = client.name.split(' ').map(w => w[0]).join('').slice(0, 2);

  const statusCounts = {};
  for (const post of client.posts) {
    const s = post.status || 'draft';
    statusCounts[s] = (statusCounts[s] || 0) + 1;
  }

  return (
    <div className="card card--clickable" onClick={() => navigate(`/client/${client.id}`)}>
      <div className="client-card">
        <div className="client-card-header">
          <div className="client-avatar">{initials}</div>
          <div className="client-info">
            <h3>{client.name}</h3>
            <p>{client.segment}</p>
          </div>
        </div>
        <div className="client-stats">
          <div className="client-stat">
            <div className="client-stat-value">{client.posts.length}</div>
            <div className="client-stat-label">Posts</div>
          </div>
          <div className="client-stat">
            <div className="client-stat-value">{client.channels.length}</div>
            <div className="client-stat-label">Canais</div>
          </div>
        </div>
        {Object.keys(statusCounts).length > 0 && (
          <div style={{ display: 'flex', gap: 'var(--spacing-sm)', flexWrap: 'wrap', marginTop: 'var(--spacing-sm)' }}>
            {Object.entries(statusCounts).map(([status, count]) => (
              <span
                key={status}
                className={`status-badge status-badge--${status}`}
              >
                {count} {status.replace('_', ' ')}
              </span>
            ))}
          </div>
        )}
        {client.positioning && (
          <p style={{ fontSize: '0.8rem', color: 'var(--color-text-muted)', fontStyle: 'italic', marginTop: 'var(--spacing-sm)' }}>
            "{client.positioning}"
          </p>
        )}
      </div>
    </div>
  );
}

export default ClientCard;
